import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import 'bootstrap'
import './assets/app.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueSweetalert2 from 'vue-sweetalert2'

import 'sweetalert2/dist/sweetalert2.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import DateRangePicker from 'vue2-daterange-picker'

import moment from 'moment-timezone'
 
Vue.prototype.moment = moment

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import Parse from './parse'
Vue.prototype.$parse = Parse

import { ValidationObserver } from "vee-validate"
import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm'

Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)

const options = {
  cancelButtonColor: '#ff7674',
  confirmButtonColor: '#85EEB3',
};
 
Vue.use(VueSweetalert2, options);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
